import { render, staticRenderFns } from "./AzPersonsFinanceReadOnlyPanel.vue?vue&type=template&id=e34d4860"
import script from "./AzPersonsFinanceReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./AzPersonsFinanceReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports